import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "./heroControl.css";
import ReserLock from "../../pages/reserLock/ReserLock";
import { useNavigate } from "react-router-dom";
import MobileNav from "../mobileNav/MobileNav";

const HeroControl = () => {
  const [formData, setFormData] = useState({
    id: null,
    title: "",
    description: "",
    note: "",
    imageUrl: "",
    key: "",
  });

  const [errors, setErrors] = useState({
    title: "",
    description: "",
    imageUrl: "",
    key: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [sliders, setSliders] = useState([]);

  const navigate = useNavigate();
  const fileInputRef = React.useRef(null);

  useEffect(() => {
    const fetchSliders = async () => {
      try {
        const response = await axios.get(
          "https://api.generalhome.sa/api/Themes/GetSliders"
        );

        const fixedData = response.data.map((item) => {
          // Replace old domain with the new one
          const oldDomain = "https://aircon-api.hiveagency.tech";
          const newDomain = "https://api.generalhome.sa";

          return {
            ...item,
            image: item.image?.startsWith(oldDomain)
              ? item.image.replace(oldDomain, newDomain)
              : item.image,
          };
        });

        setSliders(fixedData);
      } catch (error) {
        console.error("Error fetching sliders:", error);
        Swal.fire({
          icon: "error",
          title: "خطأ!",
          text: "حدث خطأ أثناء جلب البيانات!",
          confirmButtonText: "حسناً",
        });
      }
    };

    fetchSliders();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  // Validate the form inputs
  const validateForm = () => {
    let isValid = true;
    const newErrors = { title: "", description: "", imageUrl: "", key: "" };

    // Validate Title
    if (!formData.title.trim()) {
      newErrors.title = "العنوان مطلوب";
      isValid = false;
    }

    // Validate Description
    if (!formData.description.trim()) {
      newErrors.description = "الوصف مطلوب";
      isValid = false;
    }

    // Validate Image URL
    if (!formData.imageUrl) {
      newErrors.imageUrl = "رابط الصورة مطلوب";
      isValid = false;
    }

    // Validate Key only when creating new (not in edit mode)
    if (!formData.id && !formData.key.trim()) {
      newErrors.key = "المفتاح مطلوب";
      isValid = false;
    }

    // Update errors state
    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);

    try {
      let uploadedImageUrl = "";

      // لو المستخدم رفع صورة جديدة (File)
      if (formData.imageUrl instanceof File) {
        const imageFormData = new FormData();
        imageFormData.append("file", formData.imageUrl);

        const uploadResponse = await axios.post(
          "https://api.generalhome.sa/api/Themes/UploadImages",
          imageFormData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const imageUrl = uploadResponse.data?.imageUrl || uploadResponse.data;

        uploadedImageUrl = imageUrl.startsWith("http")
          ? imageUrl
          : `https://api.generalhome.sa${
              imageUrl.startsWith("/") ? "" : "/"
            }${imageUrl}`;
      } else {
        // لو رابط قديم (string)
        uploadedImageUrl = formData.imageUrl
          ? `https://api.generalhome.sa${formData.imageUrl}`
          : "";
      }

      // تجهيز الباي لود
      const payloadPost = {
        Id: 0,
        text1: formData.title,
        text2: formData.description,
        note: formData.note.trim(),
        image: uploadedImageUrl,
        Key: formData.key,
      };

      const payloadPut = {
        Id: formData.id,
        text1: formData.title,
        text2: formData.description,
        note: formData.note.trim(),
        image: uploadedImageUrl,
        Key: formData.key,
      };

      // let response;
      if (formData.id) {
        await axios.put(
          `https://api.generalhome.sa/api/Themes/PutSlider/${formData.id}`,
          payloadPut,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      } else {
        await axios.post(
          "https://api.generalhome.sa/api/Themes/PostSlider",
          payloadPost,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      }

      Swal.fire({
        icon: "success",
        title: "تم!",
        text: formData.id
          ? "تم تحديث البيانات بنجاح!"
          : "تم إرسال البيانات بنجاح!",
        confirmButtonText: "حسناً",
      });

      // reset form
      setFormData({
        id: null,
        title: "",
        description: "",
        imageUrl: "",
        key: "",
        note: "",
      });
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      // fetch latest sliders
      const fetchResponse = await axios.get(
        "https://api.generalhome.sa/api/Themes/GetSliders"
      );
      setSliders(fetchResponse.data);
    } catch (error) {
      console.error("Error submitting data:", error);
      Swal.fire({
        icon: "error",
        title: "خطأ!",
        text: "حدث خطأ أثناء إرسال البيانات!",
        confirmButtonText: "حسناً",
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Handle Edit button click
  const handleEdit = (slider) => {
    setFormData({
      id: slider.Id,
      title: slider.text1,
      description: slider.text2,
      note: slider.note || "",
      imageUrl: slider.image.replace("https://api.generalhome.sa", ""),
      key: slider.Key || "",
    });
  };

  // Handle Delete button click
  const handleDelete = async (Id) => {
    const result = await Swal.fire({
      title: "هل أنت متأكد؟",
      text: "لن تتمكن من استعادة هذه البيانات!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "نعم، احذفها",
      cancelButtonText: "إلغاء",
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
    });
    if (result.isConfirmed) {
      try {
        await axios.delete(
          `https://api.generalhome.sa/api/Themes/DeleteSlider/${Id}`
        );
        setSliders((prevSliders) =>
          prevSliders.filter((slider) => slider.Id !== Id)
        );
        Swal.fire({
          icon: "success",
          title: "تم!",
          text: "تم حذف البيانات بنجاح!",
          confirmButtonText: "حسناً",
        });
      } catch (error) {
        console.error("Error deleting slider:", error);
        Swal.fire({
          icon: "error",
          title: "خطأ!",
          text: "حدث خطأ أثناء حذف البيانات!",
          confirmButtonText: "حسناً",
        });
      }
    }
  };

  const handlePreview = (slider) => {
    switch (slider.Key) {
      case "clean":
        navigate("/notes"); // أو "/VerifiyMobileNumber" لو مقفول
        break;
      case "maintinance":
        navigate("/maintainanceNotes"); // أو "/VerifiyMobileNumber"
        break;
      case "Main":
        navigate("/");
        break;
      case "secondary":
        navigate("/eidMubarak"); // أو أي صفحة تانية تحبها
        break;
      default:
        Swal.fire("تنبيه", "لا يوجد صفحة معرفة لهذا العنصر", "info");
    }
  };

  const formatNotes = (notesText) => {
    return notesText.split("\n").map((note, index) => (
      <div key={index} className="note-item">
        <div className="note-icon-container">
          <span className="note-icon">-</span>
        </div>
        <p>{note.replace("- ", "").trim()}</p>
      </div>
    ));
  };

  const keyTranslations = {
    clean: "تنظيف",
    maintinance: "صيانه",
  };

  return (
    <>
      <MobileNav />
      <section className="heroControl">
        <div className="heroControl-container container mb-5">
          {/* <div className="headline"> */}
          <h3>اداره صوره الصفحه الرئيسيه:</h3>
          {/* </div> */}
          <form onSubmit={handleSubmit}>
            {/* Title Input */}
            <div className="form-group">
              <label htmlFor="title">العنوان:</label>
              <input
                type="text"
                id="title"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                placeholder="أدخل العنوان"
              />
              {errors.title && <p className="error">{errors.title}</p>}
            </div>

            {/* Description Input */}
            <div className="form-group">
              <label htmlFor="description">الوصف:</label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                placeholder="أدخل الوصف"
              />
              {errors.description && (
                <p className="error">{errors.description}</p>
              )}
            </div>

            {/* Description Input */}
            <div className="form-group">
              <label htmlFor="description">ملاحظه:</label>
              <textarea
                id="note"
                name="note"
                value={formData.note}
                onChange={handleInputChange}
                placeholder="أدخل ملاحظه"
              />
            </div>

            {/* Image URL Input */}
            <div className="form-group">
              <label htmlFor="imageUrl">رابط الصورة:</label>
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={(e) =>
                  setFormData({ ...formData, imageUrl: e.target.files[0] })
                }
              />

              {errors.imageUrl && <p className="error">{errors.imageUrl}</p>}
            </div>

            {/* Key Input */}
            <div className="form-group">
              <label htmlFor="key">المفتاح:</label>
              <input
                type="text"
                id="key"
                name="key"
                value={formData.key}
                onChange={handleInputChange}
                placeholder="أدخل المفتاح"
                disabled={!!formData.id}
              />
              {errors.key && <p className="error">{errors.key}</p>}
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="submit-button"
              disabled={isLoading}
            >
              {formData.id
                ? isLoading
                  ? "جاري التحديث..."
                  : "تحديث التغييرات"
                : isLoading
                ? "جاري الحفظ..."
                : "حفظ التغييرات"}
            </button>
          </form>

          {/* Display fetched sliders data in a table */}
          <div className="sliders-table">
            <h3>البيانات المحفوظة:</h3>
            {sliders.length > 0 ? (
              <div className="table-responsive-sm overflow-auto">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>العنوان</th>
                      <th>الوصف</th>
                      <th>ملاحظه</th>
                      <th>رابط الصورة</th>
                      <th>معاينة الصورة</th>
                      <th>المفتاح</th>
                      <th>التحكم</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sliders.map((slider, index) => (
                      <tr key={slider.Id}>
                        <td>{slider.text1}</td>
                        <td>{slider.text2}</td>
                        <td> {formatNotes(slider.note)}</td>
                        <td>
                          <a
                            href={slider.image}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {slider.image}
                          </a>
                        </td>
                        <td>
                          <img
                            src={slider.image}
                            alt={`Preview ${index}`}
                            className="image-preview"
                          />
                        </td>
                        <td>{keyTranslations[slider.Key] || slider.Key}</td>
                        <td>
                          <div className="slider-table-btnBox">
                            <div className="control-btn-box">
                              <button
                                className="edit-button  mb-0"
                                onClick={() => handleEdit(slider)}
                              >
                                تعديل
                              </button>
                              <button
                                className="delete-button"
                                onClick={() => handleDelete(slider.Id)}
                              >
                                حذف
                              </button>
                            </div>
                            <div className="preview-btn-box">
                              <button
                                className="preview-btn"
                                onClick={() => handlePreview(slider)}
                              >
                                معاينة
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p>لا توجد بيانات متاحة</p>
            )}
          </div>
        </div>
        <ReserLock />
      </section>
    </>
  );
};

export default HeroControl;
